import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/bar-chart/pages/CalculatorPage";

export const Route = createFileRoute("/bar-chart")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/bar-chart",
      title: m.bar_meta_title(),
      description: m.bar_meta_description(),
      toolName: m.bar_tool_name(),
      faqs: [
        { q: m.bar_faq_q1(), a: m.bar_faq_a1() },
        { q: m.bar_faq_q2(), a: m.bar_faq_a2() },
        { q: m.bar_faq_q3(), a: m.bar_faq_a3() },
        { q: m.bar_faq_q4(), a: m.bar_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
